module.exports = __webpack_public_path__ + "img/mercedes-sprinter.a961e640.jpeg";